export default "__VITE_ASSET__Cx68r7RE__"